// extracted by mini-css-extract-plugin
export var accordionItem = "styles-module--accordionItem--f96ce";
export var beigeBackground = "styles-module--beigeBackground--3da79";
export var bigGap = "styles-module--bigGap--ee5e1";
export var bigSpacing = "styles-module--bigSpacing--6dcfc";
export var columnWrapper = "styles-module--columnWrapper--ccdb0";
export var four = "styles-module--four--1cf48";
export var hl = "styles-module--hl--d222a";
export var inContainer = "styles-module--inContainer--1da0e";
export var item = "styles-module--item--89bba";
export var smallItems = "styles-module--smallItems--28696";
export var smallSpacing = "styles-module--smallSpacing--f3f9a";
export var smone = "styles-module--smone--feed6";
export var smtwo = "styles-module--smtwo--7e861";
export var subline = "styles-module--subline--ccfac";
export var three = "styles-module--three--df02d";
export var two = "styles-module--two--a310a";
export var wrapper = "styles-module--wrapper--b776b";